import React from 'react';
import { Header, Input,Container, Button, Message, Form } from 'semantic-ui-react';

import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag'

class Register extends React.Component {
    
    state={
        username:'',
        usernameError:'',
        email:'',
        emailError:'',
        password:'',
        passwordError:''
    };

    onChange=e=>{
        const {name,value}=e.target;
        this.setState({[name]:value}); 
    };

    onSubmit=async ()=>{
        this.setState({
            usernameError:'',
            passwordError:'',
            emailError:'',
        });
        const {username,email,password}=this.state;
        const response=await this.props.mutate({
            variables: {username,email,password},
        });
        const {ok,errors} = response.data.register;
        if(ok){
            this.props.history.push('/');
        }
        else{
            const err={};
            errors.forEach(({path,message}) => {
                err[`${path}Error`]=message;
            });
            this.setState(err);
        }
    };
    onLogin=()=>{
        this.props.history.push('/login');
    };
    render() {
        const { username, email, password,usernameError,passwordError,emailError } = this.state;
        const errorList=[];

        if(usernameError){
            errorList.push(usernameError);
        }
        if(passwordError){
            errorList.push(passwordError);
        }
        if(emailError){
            errorList.push(emailError);
        }

        return (
            <Container text>
                <br/>
                <Form>
                    <Form.Field>
                        <Header as="h2">Register</Header>
                    </Form.Field>
                    <Form.Field error={!!usernameError}>
                        <Input  name="username" onChange={this.onChange} value={username} placeholder="Username" fluid />
                    </Form.Field>
                    <Form.Field error={!!emailError}>
                        <Input  name="email" onChange={this.onChange} value={email} placeholder="Email" fluid />
                    </Form.Field>
                    <Form.Field error={!!passwordError}>
                        <Input  name="password" type="password" onChange={this.onChange} value={password} placeholder="Password" fluid />
                    </Form.Field>
                    <Form.Field>
                        <flex>
                            <ini>
                                <Button onClick={this.onSubmit}>Register</Button>
                            </ini>
                            <ini>
                                <Button onClick={this.onLogin}>Login</Button>
                            </ini>
                        </flex>
                    </Form.Field>
                    
                </Form>
                {usernameError || emailError || passwordError ?(
                        <Message
                            error
                            list={errorList}
                        />
                    ) : null}

            </Container>
        );
    }
}
const registerMutation=gql`
    mutation($username:String!,$email:String!,$password:String!){
        register(username:$username,email:$email,password:$password){
            ok
            errors{
                path
                message
            }
        }
    }
`;

export default graphql(registerMutation)(Register);
